import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { message } from 'antd';

import { RootState } from '../../../../reducers/store';
import * as actions from '../../../../actions/publicationsActions';
import FormView from './FormView';
import { ApiPublicationResponseType, ApiPublicationType } from '../../types';
import { ClientContextType } from 'src/contexts/Client/types';
import { FullPageSpinner } from '../../../../ui';
import { UserDataType } from 'src/types';

const EditForm: React.FC<{
  publicationId: string;
  updatePublication: (
    id: string,
    body: any,
    successCallback: () => void,
    failureCallback: () => void
  ) => void;
  onSuccess: () => void;
  closeModal: () => void;
  clientContext: ClientContextType;
  me: UserDataType;
}> = ({
  publicationId,
  updatePublication,
  onSuccess,
  closeModal,
  clientContext,
  me,
}) => {
  const { get } = clientContext;
  const [loading, setLoading] = useState(false);
  const [publication, setPublication] = useState<
    ApiPublicationType | undefined
  >(undefined);

  useEffect(() => {
    return get(
      `/news/${publicationId}`,
      (response: ApiPublicationResponseType) => {
        if (!response.data) return;

        setPublication(response.data);
      }
    );
  }, [get, publicationId]);

  const onSubmit = (body: any) => {
    delete body.publisher;

    setLoading(true);
    updatePublication(
      publicationId,
      body,
      () => {
        setLoading(false);
        message.success('La publication a bien été mise à jour');
        onSuccess();
        closeModal();
      },
      () => {
        setLoading(false);
        message.error(
          'Une erreur est survenue lors de la mise à jour de la publication'
        );
      }
    );
  };
  return publication ? (
    <FormView
      onSubmit={onSubmit}
      loading={loading}
      publication={publication}
      isMine={publication.author.id === me.id}
    />
  ) : (
    <FullPageSpinner />
  );
};
const mapStateToProps = ({ client, me }: RootState) => ({
  clientContext: client,
  me,
});

export default connect(mapStateToProps, actions)(EditForm);
